import FileUploader from 'components/UploaderAndDownloader/FileUploader';
import React, { useCallback, useContext } from 'react';
import DownloadBtn from './DownloadBtn';
import { createAppError } from 'utils/helpers';
import { AppContext, IAppContext } from 'appState/appContext';
import { IFileData } from 'types';
import { TTypeOfEditGameModalWindow } from 'modules/Entertainment/Games/EditGame/editGameState/editGameContext';
import { postMediaFile } from 'backend/additionalInformation';
import style from './GameFileBlock.module.scss';

interface IGameFileBlock {
	changeFileData: (value: IFileData) => void;
	changeTypeOfModalWindow: (value: TTypeOfEditGameModalWindow) => void;
}

const GameFileBlock: React.FC<IGameFileBlock> = ({ changeFileData, changeTypeOfModalWindow }) => {
	const { showLoader, hideLoader, addAppError } = useContext<IAppContext>(AppContext);

	const sendForm = useCallback(
		async (file: File, callback: (value: string) => void) => {
			const maxFileSizeMB = 150;
			if (file.size > 1000 * 1000 * maxFileSizeMB) {
				changeTypeOfModalWindow('fileSizeExceeded');
				return null;
			}
			showLoader();
			const formData = new FormData();
			formData.append('file', file, file.name);

			try {
				const { data } = await postMediaFile({ data: formData });
				changeFileData({ fileId: data.fileId, fileHash: data.fileHash, fileName: file.name });
				callback(file.name);
				hideLoader();
			} catch (err) {
				hideLoader();
				const error = err as Error;
				const appError = createAppError(error);
				addAppError(appError);
			}
		},
		[changeTypeOfModalWindow, changeFileData],
	);

	const resetFile = useCallback(() => {
		changeFileData({ fileId: '', fileHash: null, fileName: null });
	}, [changeFileData]);

	return (
		<div className={style.container} data-test="GameFileBlock">
			<FileUploader
				fileType="apk"
				onFileLoad={sendForm}
				onFileReset={resetFile}
				id="gameUpload"
				label="uploadGameFileButton"
			/>
			<DownloadBtn />
		</div>
	);
};

export default GameFileBlock;
